import type { InjectionKey } from 'vue'
import type { BreadcrumbProps } from '@park-ui/components/breadcrumb'

export const breadcrumbKey: InjectionKey<BreadcrumbProps> =
  Symbol('breadcrumbKey')
